module.exports = __webpack_public_path__ + "static/media/468x60_0006_en.dbf12624.png";